import addDays from "date-fns/add_days";
var DateHelper = /** @class */ (function () {
    function DateHelper() {
    }
    // expected output format: yyyy-mm-dd
    DateHelper.convertDateToReducedIsoDate = function (date) {
        return new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
            .toISOString()
            .split("T")[0];
    };
    DateHelper.getToday = function () {
        return new Date();
    };
    DateHelper.getTomorrow = function () {
        return addDays(this.getToday(), 1);
    };
    DateHelper.getDayAfterTomorrow = function () {
        return addDays(this.getToday(), 2);
    };
    DateHelper.convertMinutesToFormattedString = function (timeStampInMinutes) {
        var minutes = timeStampInMinutes % 60;
        var hours = Math.floor(timeStampInMinutes / 60) % 24;
        var days = Math.floor(timeStampInMinutes / 1440);
        if (timeStampInMinutes >= 1440) {
            return days + "t " + hours + "h " + minutes + "m ";
        }
        else if (timeStampInMinutes < 60) {
            return minutes + "m ";
        }
        else {
            return hours + "h " + minutes + "m ";
        }
    };
    DateHelper.capitalize = function (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    return DateHelper;
}());
export default DateHelper;
